// Demo data for ?obfuscate, shared by the pool's activity feed and its candidate
// list so both show the same people. The avatar images show, in this order,
// f, m, m, f, f, m, m, f - the names follow them.

// sc-avatar pipes the image through imageSize, which parses it as an absolute url
function avatar(index: number) {
  return window.location.origin + '/assets/img/avatars/profiles/avatar-' + index + '.jpg';
}

export const demoPeople: any = [
  {
    Id: 'a1f1c2d0-0001-4a10-9b01-2f8e6d4c1001',
    FirstName: 'Anna',
    LastName: 'Berger',
    JobTitle: 'Senior Backend Engineer',
    Image: avatar(1)
  },
  {
    Id: 'a1f1c2d0-0002-4a10-9b01-2f8e6d4c1002',
    FirstName: 'Tobias',
    LastName: 'Lang',
    JobTitle: 'Cloud Architect',
    Image: avatar(2)
  },
  {
    Id: 'a1f1c2d0-0003-4a10-9b01-2f8e6d4c1003',
    FirstName: 'Jonas',
    LastName: 'Keller',
    JobTitle: 'Data Analyst',
    Image: avatar(3)
  },
  {
    Id: 'a1f1c2d0-0004-4a10-9b01-2f8e6d4c1004',
    FirstName: 'Nina',
    LastName: 'Hartmann',
    JobTitle: 'SAP Consultant FI/CO',
    Image: avatar(4)
  },
  {
    Id: 'a1f1c2d0-0005-4a10-9b01-2f8e6d4c1005',
    FirstName: 'Laura',
    LastName: 'Seibert',
    JobTitle: 'Product Managerin',
    Image: avatar(5)
  },
  {
    Id: 'a1f1c2d0-0006-4a10-9b01-2f8e6d4c1006',
    FirstName: 'Markus',
    LastName: 'Dreyer',
    JobTitle: 'Cloud Solutions Architect',
    Image: avatar(6)
  },
  {
    Id: 'a1f1c2d0-0007-4a10-9b01-2f8e6d4c1007',
    FirstName: 'David',
    LastName: 'Nowak',
    JobTitle: 'BI Consultant',
    Image: avatar(7)
  },
  {
    Id: 'a1f1c2d0-0008-4a10-9b01-2f8e6d4c1008',
    FirstName: 'Sophie',
    LastName: 'Krammer',
    JobTitle: 'IT-Security Specialist',
    Image: avatar(8)
  }
];

// what the feed reports about each of them, in the same order
const demoReports: any = [
  {
    Headline: 'Engagement mit',
    Icon: 'fa-sharp fa-solid fa-paper-plane',
    Topic: 'Software Engineering',
    Report: 'Wechselsignal → Nachricht mit Stellenvorschlag „Senior Backend Engineer (m/w/d)“ gesendet.',
    Date: 'vor 2 Stunden'
  },
  {
    Headline: 'Neuanmeldung von',
    Icon: 'fa-sharp fa-solid fa-user-plus',
    Topic: 'Cloud & Infrastructure',
    Report: 'Über die Jobsite „Cloud Architect (m/w/d)“ dem Talentpool beigetreten.',
    Date: 'vor 6 Stunden'
  },
  {
    Headline: 'Engagement mit',
    Icon: 'fa-sharp fa-solid fa-paper-plane',
    Topic: 'Data Analytics & BI',
    Report: 'Post mit Bezug zu Cluster Data Analytics → Nachricht mit Einladung zum Data Breakfast gesendet.',
    Date: 'gestern'
  },
  {
    Headline: 'Engagement mit',
    Icon: 'fa-sharp fa-solid fa-paper-plane',
    Topic: 'SAP Consultants',
    Report: 'Neue Position als Teamlead → Glückwunsch-Nachricht gesendet und Kontakt aufgefrischt.',
    Date: 'vor 2 Tagen'
  },
  {
    Headline: 'Neuanmeldung von',
    Icon: 'fa-sharp fa-solid fa-user-plus',
    Topic: 'Product Management',
    Report: 'Über eine Empfehlung aus dem Cluster Product Management registriert.',
    Date: 'vor 4 Tagen'
  },
  {
    Headline: 'Engagement mit',
    Icon: 'fa-sharp fa-solid fa-paper-plane',
    Topic: 'Cloud & Infrastructure',
    Report: 'Zertifikat Azure Solutions Architect ergänzt → Nachricht mit Stellenvorschlag „Cloud Architect (m/w/d)“ gesendet.',
    Date: 'vor 6 Tagen'
  },
  {
    Headline: 'Engagement mit',
    Icon: 'fa-sharp fa-solid fa-paper-plane',
    Topic: 'Data Analytics & BI',
    Report: 'Zwei Jahre in aktueller Position → Nachricht mit Stellenübersicht gesendet.',
    Date: 'vor 9 Tagen'
  },
  {
    Headline: 'Neuanmeldung von',
    Icon: 'fa-sharp fa-solid fa-user-plus',
    Topic: 'IT-Security',
    Report: 'Über die Jobsite „IT-Security Specialist (m/w/d)“ dem Talentpool beigetreten.',
    Date: 'vor 12 Tagen'
  }
];

export const demoActivities: any = demoPeople.map((person, i) => Object.assign({}, person, demoReports[i]));

// Pool size cumulated per calendar week, and the pool's KPIs - shown on the
// dashboard and on the pool's activities view
export const demoPoolWeeks: any = [
  { Label: 'KW 32', Value: 21 },
  { Label: 'KW 33', Value: 23 },
  { Label: 'KW 34', Value: 31 },
  { Label: 'KW 35', Value: 34 },
  { Label: 'KW 36', Value: 47 },
  { Label: 'KW 37', Value: 52 },
  { Label: 'KW 38', Value: 59 },
  { Label: 'KW 39', Value: 78 }
];

export const demoPoolKpis: any = { size: 78, switchSignals: 6, engagements: 14 };
